import dayjs from "dayjs";
import type { Shift } from "../types";

/**
 * The date MC's scheduling list shows for a shift: its Sched Date, date-only — never
 * Shift Start/End Final, which carry a synthetic 09:00 UTC that renders as a misleading
 * local wall-time (e.g. "12:00 PM" in UTC+3). Falls back to the start date's calendar
 * day for shifts without a Sched Date; empty when neither is known.
 */
export function shiftSchedDateLabel(shift: Pick<Shift, "scheduledDate" | "startDate">): string {
	const date = shift.scheduledDate ?? shift.startDate;
	return date ? dayjs(date).format("MMM D") : "";
}
